import { render, staticRenderFns } from "./MonthlyOffersView.vue?vue&type=template&id=d804fb38&scoped=true"
import script from "./MonthlyOffersView.vue?vue&type=script&lang=js"
export * from "./MonthlyOffersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d804fb38",
  null
  
)

export default component.exports